import React, { Component } from 'react'

import style from './style.css'

export default class ProgressBar extends Component {
   
    render() {
        return (
            <div className={`${style.progressBar} ${this.props.theme ? style[this.props.theme] : ''}`} style={{height: this.props.height  || '5px'}}>
                <div className={style.progress} style={{width: this.props.progress+"%" || 0}}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/ProgressBar/index.js